<template>
  <div class="demo360">
    <div class="photo-compare-container" id="photo-compare-container">
      <div class="container" id="container">
        <div v-show="isCompareMode" class="limit"></div>
        <canvas id="canvas360" ref="canvas360"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Color3,
  Engine,
  Vector3,
  Texture,
  MeshBuilder,
  StandardMaterial,
  // RefractionTexture,
  // Plane,
  HemisphericLight,
  Scene,
  RenderTargetTexture,
  // Mesh,
  // ImageProcessingPostProcess,
  ImageProcessingConfiguration,
  BlurPostProcess,
  SharpenPostProcess,
  Vector2,
  // VideoDome,
  VideoTexture,
  Viewport,
  ArcRotateCamera,
} from 'babylonjs';
import { mapState } from 'vuex';
import {
  init,
  // anim9te,
  // changeImg,
  computeSize,
  addEventListeners,
  removeEventListeners,
} from './scripts/scriptBabylon';

const LEFT = 'Left';
const RIGHT = 'Right';

export default {
  name: 'View360',
  data: function() {
    return {
      blurFactor: 0.7,
      blurFactorOutside: 1,
      camera: {},
      camera2: {},
      dashOpacity: 0.8,
      depthOfRefraction: 1,
      engine: {},
      exposure: 0,
      fps: '0',
      glassMaterial: {},
      indexOfRefraction: 1.2,
      isSubcriptionDone: false,
      materialBlur: {},
      optimizationLevel: 1,
      outsideContrast: 0,
      productViews: [],
      refRotation: 0,
      scene: {},
      isCompareMode: false,
      skybox: {},
      skyboxMaterial: {},
      skyboxSize: 200,
      tint: { red: 0, green: 0, blue: 0 },
      tintOpacity: 0,
      unwatchers: [],
    };
  },
  computed: {
    ...mapState(['showDashes']),

    // get the current situation
    currentSituation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
    // optimizationLevel() {
    //   return this.$store.getters.optimization;
    // },
    // tintOpacity() {
    //   return this.$store.getters.tintOpacity;
    // },
    // indexOfRefraction() {
    //   return this.$store.getters.refraction;
    // },
    // depthOfRefraction() {
    //   return this.$store.getters.depth;
    // },
    // tint() {
    //   return this.$store.getters.glassColor;
    // },
    storeProductLeft() {
      return this.$store.getters.comparisonProductLeft;
    },
    storeProductRight() {
      return this.$store.getters.comparisonProductRight;
    },

    canRender() {
      return this.isMouseDown || this.nbTexturesLoading > 0;
    },
  },
  watch: {
    // change image when change situation to an other 360 demo
    '$route.params.idSituation': function() {
      if (this.currentSituation) {
        const filename = this.computeFilename(this.currentSituation.media.filename);
        this.setBackgroundImage(filename);
      }
    },
    optimizationLevel(newV) {
      this.engine.setHardwareScalingLevel(newV);
    },
    tint(newV) {
      this.tintMaterial.ambientColor = new Color3(newV.red, newV.green, newV.blue);
    },
    tintOpacity(newV) {
      this.tintMaterial.alpha = newV;
    },
    indexOfRefraction(newV) {
      this.glassMaterial.indexOfRefraction = newV;
    },
    depthOfRefraction(newV) {
      this.glassMaterial.refractionTexture.depth = newV;
    },
  },
  methods: {
    setBackgroundImage(filePath) {
      // Test vidéo
      // filePath = "https://yoda.blob.core.windows.net/videos/uptale360.mp4",
      this.$log.debug(filePath);

      this.resetCameraPosition();

      const isVideo = /[.]mp4$/.test(filePath);

      this.skyboxMaterial.reflectionTexture = isVideo
        ? new VideoTexture('video', filePath, this.scene, true)
        : new Texture(filePath, this.scene, true);

      this.skyboxMaterial.reflectionTexture.coordinatesMode = Texture.FIXED_EQUIRECTANGULAR_MIRRORED_MODE;

      this.checkTextureLoading(this.skyboxMaterial.reflectionTexture);
    },
    initScene(canvas) {
      // this.$store.commit('setCompareMode', false);
      init();
      addEventListeners();
      this.scene = new Scene(this.engine);
      this.scene.ambientColor = new Color3(1, 1, 1);

      this.camera = this.initCamera(canvas, 0);
      this.camera.layerMask = 1;
      // this.camera2 = this.camera.clone();
      this.camera2 = this.initCamera(canvas, 1);
      this.camera2.layerMask = 2;

      const light = new HemisphericLight('light1', new Vector3(0, 1, 0), this.scene);
      light.intensity = 0.7;

      const glassPlane = MeshBuilder.CreatePlane('plane', { width: 5, height: 5, tileSize: 1 }, this.scene);
      // Group the glass with the camera
      glassPlane.parent = this.camera;
      glassPlane.position.z += 5;
      glassPlane.setEnabled(false);

      // Skybox
      this.skybox = MeshBuilder.CreateBox('skyBox', { size: this.skyboxSize }, this.scene);
      this.skyboxMaterial = new StandardMaterial('skyBox', this.scene);
      this.skyboxMaterial.backFaceCulling = false;
      if (this.currentSituation) {
        this.setBackgroundImage(this.computeFilename(this.currentSituation.media.filename));
      }
      this.skyboxMaterial.disableLighting = true;
      this.skybox.material = this.skyboxMaterial;
      // this.skybox.scaling.x = -1;
      this.skybox.material.invertZ = true;

      // Glass material
      // this.glassMaterial = new StandardMaterial("glass", this.scene);
      // glassPlane.material = this.glassMaterial;

      // const refractionTexture = new RefractionTexture("th", 1024, this.scene);
      // refractionTexture.renderList.push(this.skybox);
      // const refractionPlane = new Plane(0, -1, 0, -this.skyboxSize);
      // refractionPlane.parent = this.camera;
      // refractionTexture.refractionPlane = refractionPlane;
      // refractionTexture.depth = this.depthOfRefraction;

      // this.glassMaterial.diffuseColor = new Color3(0, 0, 0); // transparent
      // this.glassMaterial.refractionTexture = refractionTexture;
      // this.glassMaterial.indexOfRefraction = this.indexOfRefraction;
      // this.glassMaterial.bumpTexture = new Texture(
      //   "/demo/glass/glass-normalmap+.png",
      //   this.scene
      // );
      // this.glassMaterial.opacityTexture = new Texture(
      //   //   "https://s3-us-west-2.amazonaws.com/s.cdpn.io/106114/displacementmap.png?v=1",
      //   "/demo/glass/glass-opacitymap.png",
      //   this.scene
      // );

      // RenderTargetTexture for PostProcess effects
      var renderTargetTexture = new RenderTargetTexture(
        'renderTargetTexture',
        { width: 2048, height: 1024 },
        this.scene,
        false,
        false
      );

      renderTargetTexture.activeCamera = this.camera;
      renderTargetTexture.renderList.push(this.skybox);
      //renderTargetTexture.renderList=scene.meshes;
      renderTargetTexture.vScale = 1;
      renderTargetTexture.uScale = 0.5;
      renderTargetTexture.vOffset = 0;
      renderTargetTexture.uOffset = 0;

      // renderTargetTexture.updateSamplingMode(Texture.NEAREST_SAMPLINGMODE);
      renderTargetTexture.updateSamplingMode(Texture.CUBIC_MODE);

      var renderTargetTexture2 = new RenderTargetTexture(
        'renderTargetTexture2',
        { width: 2048, height: 1024 },
        this.scene,
        false,
        false
      );

      renderTargetTexture2.activeCamera = this.camera;
      renderTargetTexture2.renderList.push(this.skybox);
      //renderTargetTexture2.renderList=scene.meshes;
      renderTargetTexture2.vScale = 1;
      renderTargetTexture2.uScale = 0.5;
      renderTargetTexture2.vOffset = 0;
      renderTargetTexture2.uOffset = 0;

      // renderTargetTexture2.updateSamplingMode(Texture.NEAREST_SAMPLINGMODE);
      renderTargetTexture2.updateSamplingMode(Texture.CUBIC_MODE);

      this.materialViewport = new StandardMaterial('materialViewport', this.scene);
      this.materialViewport.diffuseColor = new Color3(0, 0, 0);
      this.materialViewport.specularColor = new Color3(0, 0, 0);
      this.materialViewport.emissiveTexture = renderTargetTexture;
      this.materialViewport.opacityTexture = new Texture('/demo/glass/glass-opacitymap.png', this.scene);

      this.materialViewportFull = new StandardMaterial('materialViewportFull', this.scene);
      this.materialViewportFull.diffuseColor = new Color3(0, 0, 0);
      this.materialViewportFull.specularColor = new Color3(0, 0, 0);
      this.materialViewportFull.emissiveTexture = renderTargetTexture;

      this.materialViewport2 = new StandardMaterial('materialViewport2', this.scene);
      this.materialViewport2.diffuseColor = new Color3(0, 0, 0);
      this.materialViewport2.specularColor = new Color3(0, 0, 0);
      this.materialViewport2.emissiveTexture = renderTargetTexture2;
      this.materialViewport2.opacityTexture = new Texture('/demo/glass/glass-opacitymap.png', this.scene);

      this.materialViewportFull2 = new StandardMaterial('materialViewportFull2', this.scene);
      this.materialViewportFull2.diffuseColor = new Color3(0, 0, 0);
      this.materialViewportFull2.specularColor = new Color3(0, 0, 0);
      this.materialViewportFull2.emissiveTexture = renderTargetTexture2;

      var renderTargetTextureBlur = renderTargetTexture.clone();
      renderTargetTextureBlur.vScale = 1;
      renderTargetTextureBlur.uScale = 1;
      renderTargetTextureBlur.vOffset = 0;
      renderTargetTextureBlur.uOffset = 0;

      // var renderTargetTextureExposure = renderTargetTexture.clone();
      var renderTargetTextureExposure = new RenderTargetTexture(
        'renderTargetTextureExposure',
        { width: 2048 / 2, height: 1024 / 2 },
        this.scene,
        false,
        false
      );
      renderTargetTextureExposure.activeCamera = this.camera;
      renderTargetTextureExposure.renderList.push(this.skybox);

      renderTargetTextureExposure.vScale = 2;
      renderTargetTextureExposure.uScale = 1;
      renderTargetTextureExposure.vOffset = 0.5;
      renderTargetTextureExposure.uOffset = 0;

      // Blur
      if (this.blurFactor !== 0) {
        this.addBlur(renderTargetTextureBlur, this.blurFactor * 2, this.blurFactor);
      }
      if (this.blurFactorOutside !== 0) {
        this.addBlur(renderTargetTextureExposure, this.blurFactorOutside, this.blurFactorOutside);
      }

      // Exposure
      var materialExposure = new StandardMaterial('mat', this.scene);
      materialExposure.diffuseColor = new Color3(0, 0, 0);
      materialExposure.specularColor = new Color3(0, 0, 0);
      materialExposure.emissiveTexture = renderTargetTextureExposure;
      if (this.exposure || this.outsideContrast) {
        materialExposure.imageProcessingConfiguration = new ImageProcessingConfiguration();
        if (this.exposure) {
          materialExposure.imageProcessingConfiguration.exposure = this.exposure;
        }
        if (this.outsideContrast) {
          materialExposure.imageProcessingConfiguration.contrast = this.computeProcessingContrast(this.outsideContrast);
          3;
        }
      }

      this.productViews.push(
        this.addProductView(
          LEFT,
          this.camera,
          this.materialViewport,
          renderTargetTexture,
          renderTargetTextureBlur,
          materialExposure
        )
      );
      this.productViews.push(
        this.addProductView(
          RIGHT,
          this.camera2,
          this.materialViewport2,
          renderTargetTexture2,
          renderTargetTextureBlur,
          materialExposure
        )
      );

      this.updateProductTextures();

      // var fitToView = mesh => {
      //   let radius = mesh.getBoundingInfo().boundingSphere.radiusWorld;

      //   let aspectRatio = this.engine.getAspectRatio(this.scene.activeCamera);
      //   let halfMinFov = this.scene.activeCamera.fov / 2;
      //   if (aspectRatio < 1) {
      //     halfMinFov = Math.atan(aspectRatio * Math.tan(this.scene.activeCamera.fov / 2));
      //   }

      //   let viewRadius = Math.abs(radius / Math.sin(halfMinFov));
      //   if (viewRadius > this.scene.activeCamera.radius) {
      //     this.scene.activeCamera.radius = viewRadius;
      //   }
      // };

      // fitToView(this.productViews[0].viewportExposure);

      this.scene.registerBeforeRender(() => {
        try {
          // setTimeout(() => {
          renderTargetTexture.render();
          renderTargetTextureBlur.render();
          if (this.$store.getters.isCompareMode) {
            renderTargetTexture2.render();
          } else {
            renderTargetTextureExposure.render();
          }
          // }
          // );
        } catch (ex) {
          this.$log.error(ex);
        }
      });
    },

    initCamera(canvas, index) {
      let camera = new ArcRotateCamera('camera' + index, 0, 0, 1, Vector3.Zero(), this.scene);

      camera.setPosition(new Vector3(0, 5, -10));

      camera.attachControl(canvas, true);

      // Orientation min pour "baisser la tête"
      camera.lowerBetaLimit = Math.PI * (2 / 5);
      // Orientation max pour "lever la tête"
      camera.upperBetaLimit = Math.PI * (3 / 5);
      // Centrage vertical de l'orientation de la caméra
      camera.beta = Math.PI * (1 / 2);
      camera.alpha = Math.PI * (1 / 2);

      // Avoid mouse wheel movements
      camera.lowerRadiusLimit = camera.radius;
      camera.upperRadiusLimit = camera.radius;

      camera.minZ = 0.1;

      // Reduce inertia
      camera.inertia = 0.5;
      camera.angularSensibilityX = 300;
      camera.angularSensibilityY = 300;

      return camera;
    },

    resetCameraPosition() {
      for (const cam of [this.camera, this.camera2]) {
        cam.setPosition(new Vector3(0, 5, -10));
        cam.beta = Math.PI * (1 / 2);
        cam.alpha = Math.PI * (1 / 2);
      }
    },

    initEngine(canvas) {
      this.nbTexturesLoading = 0;

      const useAntialiasing = false;
      const adaptToDeviceRatio = false;

      return new Engine(
        canvas,
        useAntialiasing,
        {
          preserveDrawingBuffer: true,
          stencil: true,
        },
        adaptToDeviceRatio
      );
    },

    addProductView(viewName, camera, materialViewport, renderTargetTexture, renderTargetTextureBlur, materialExposure) {
      const parentGroup = MeshBuilder.CreatePlane(
        `parentGroup-${viewName}`,
        { width: 0.000001, height: 0.000001, tileSize: 1 },
        this.scene
      );
      parentGroup.parent = camera;
      parentGroup.position.z = 1;
      // parentGroup.visibility = 0.5;

      // Dashes
      const dashPlane = MeshBuilder.CreatePlane(
        `dashPlane-${viewName}`,
        { width: 1, height: 1, tileSize: 1 },
        this.scene
      );
      dashPlane.parent = parentGroup;
      dashPlane.position.z = 0.00002;

      const dashMaterial = new StandardMaterial(`dashMaterial-${viewName}`, this.scene);
      dashPlane.material = dashMaterial;
      dashMaterial.diffuseColor = new Color3(0, 0, 0);
      dashMaterial.emissiveColor = new Color3(1, 1, 1);
      dashMaterial.alpha = this.dashOpacity;

      dashPlane.layerMask = camera.layerMask;

      // Normal viewport
      const viewport = MeshBuilder.CreatePlane(
        `viewport-${viewName}`,
        { width: 1, height: 1, tileSize: 1 },
        this.scene
      );
      viewport.position.z = 0.00004;
      viewport.parent = parentGroup;
      viewport.material = materialViewport;
      viewport.layerMask = camera.layerMask;

      // Blurred viewport (for glass blur zones)

      const materialBlur = new StandardMaterial('mat', this.scene);
      materialBlur.diffuseColor = new Color3(0, 0, 0);
      materialBlur.specularColor = new Color3(0, 0, 0);
      materialBlur.emissiveTexture = renderTargetTextureBlur;
      // if (this.glassContrast) {
      //   materialBlur.imageProcessingConfiguration = new ImageProcessingConfiguration();
      //   materialBlur.imageProcessingConfiguration.contrast = this.glassContrast;
      // }

      const viewportBlur = MeshBuilder.CreatePlane(
        `viewportBlur-${viewName}`,
        { width: 1, height: 1, tileSize: 1 },
        this.scene
      );
      viewportBlur.position.z = 0.00003;
      viewportBlur.parent = parentGroup;
      viewportBlur.material = materialBlur;
      viewportBlur.layerMask = camera.layerMask;

      // Blurred and overexposed viewport (for glass outside)
      const viewportExposure = MeshBuilder.CreatePlane(
        `viewportExposure-${viewName}`,
        { width: 2, height: 2, tileSize: 1 },
        this.scene
      );
      viewportExposure.position.z = 0.00005;
      viewportExposure.parent = parentGroup;
      viewportExposure.material = materialExposure;

      // Tint
      const tintGlass = MeshBuilder.CreatePlane(
        `tintGlass-${viewName}`,
        { width: 1, height: 1, tileSize: 1 },
        this.scene
      );
      tintGlass.position.z = 0.00001;
      tintGlass.parent = parentGroup;
      // Tint material
      this.tintMaterial = new StandardMaterial(`tintMaterial-${viewName}`, this.scene);
      this.tintMaterial.diffuseColor = new Color3(0, 0, 0);
      this.tintMaterial.diffuseTexture = new Texture(
        //   "https://s3-us-west-2.amazonaws.com/s.cdpn.io/106114/displacementmap.png?v=1",
        '/demo/glass/glass-opacitymap-gradient-transparent.png',
        this.scene
      );
      this.tintMaterial.diffuseTexture.hasAlpha = true;
      // this.tintMaterial.alphaMode = Engine.ALPHA_MULTIPLY;
      this.tintMaterial.useAlphaFromDiffuseTexture = true;
      this.tintMaterial.alpha = this.tintOpacity;
      this.tintMaterial.ambientColor = new Color3(0, 0, 1);

      tintGlass.material = this.tintMaterial; // materialtTintGlass;

      // Outline
      const outlinePlane = MeshBuilder.CreatePlane(
        `outlinePlane-${viewName}`,
        { width: 1, height: 1, tileSize: 1 },
        this.scene
      );
      outlinePlane.parent = parentGroup;
      outlinePlane.position.z = 0.00002;

      const outlineMaterial = new StandardMaterial(`outlineMaterial-${viewName}`, this.scene);
      outlinePlane.material = outlineMaterial;
      outlineMaterial.diffuseColor = new Color3(1, 1, 1);
      outlineMaterial.emissiveColor = new Color3(1, 1, 1);
      // outlineMaterial.alpha = this.dashOpacity;
      outlineMaterial.opacityTexture = new Texture('/demo/glass/glass-outline.png', this.scene);
      outlineMaterial.opacityTexture.hasAlpha = true;

      // // Outline material
      // this.outlineMaterial = new StandardMaterial("outline", this.scene);
      // outlinePlane.material = this.outlineMaterial;

      return {
        parentGroup,
        viewport,
        viewportBlur,
        viewportExposure,
        dashPlane,
        dashMaterial,
        materialBlur,
        outlinePlane,
        renderTargetTexture,
        renderTargetTextureBlur,
      };
    },

    setCompareMode(isCompareMode) {
      this.$log.debug(isCompareMode);

      this.isCompareMode = isCompareMode;

      this.scene.activeCameras = [this.camera, this.camera2];
      if (isCompareMode) {
        this.camera.viewport = new Viewport(0, 0, 0.5, 1);
        this.camera2.viewport = new Viewport(0.5, 0, 0.5, 1);
      } else {
        this.camera.viewport = new Viewport(0, 0, 1, 1);
        this.camera2.viewport = new Viewport(0, 0, 0.0000000001, 0.0000000001);
      }

      this.showProductRight(isCompareMode);

      // Position X
      this.productViews[0].parentGroup.position.x = 0;
      this.productViews[1].parentGroup.position.x = 0;

      // Position Z
      this.productViews[0].parentGroup.position.z = isCompareMode ? 1.18 : 1;
      this.productViews[1].parentGroup.position.z = isCompareMode ? 1.18 : 1;

      // Rotation Y
      this.productViews[0].parentGroup.rotation.y = 0;
      this.productViews[1].parentGroup.rotation.y = 0;

      this.productViews[0].viewportExposure.setEnabled(!isCompareMode);
      this.productViews[1].viewportExposure.setEnabled(!isCompareMode);

      this.productViews[0].viewport.material = isCompareMode ? this.materialViewportFull : this.materialViewport;
      this.productViews[1].viewport.material = isCompareMode ? this.materialViewportFull2 : this.materialViewport2;

      this.productViews[0].outlinePlane.setEnabled(!isCompareMode);
      this.productViews[1].outlinePlane.setEnabled(false);

      this.updateProductTextures();

      const uScaleCompare = 1.13;
      const uOffsetCompare = -0.065;
      this.productViews[0].dashMaterial.opacityTexture.uScale = isCompareMode ? uScaleCompare : 1;
      this.productViews[0].dashMaterial.opacityTexture.uOffset = isCompareMode ? uOffsetCompare : 0;
      this.productViews[1].dashMaterial.opacityTexture.uScale = isCompareMode ? uScaleCompare : 1;
      this.productViews[1].dashMaterial.opacityTexture.uOffset = isCompareMode ? uOffsetCompare : 0;

      // this.productViews[0].viewportBlur.material.opacityTexture.uScale = 1;
      // this.productViews[0].viewportBlur.material.opacityTexture.uOffset = 0;
      // this.productViews[1].viewportBlur.material.opacityTexture.uScale = 1;
      // this.productViews[1].viewportBlur.material.opacityTexture.uOffset = 0;

      this.productViews[0].renderTargetTexture.uOffset = isCompareMode ? 0 : 0.25;
      this.productViews[1].renderTargetTexture.uOffset = isCompareMode ? 0 : 0.25;

      this.productViews[0].renderTargetTexture.uScale = isCompareMode ? 1 : 0.5;
      this.productViews[0].renderTargetTexture.uOffset = isCompareMode ? 0 : 0.25;
      this.productViews[1].renderTargetTexture.uScale = isCompareMode ? 1 : 0.5;
      this.productViews[1].renderTargetTexture.uOffset = isCompareMode ? 0 : 0.25;
      this.productViews[0].renderTargetTextureBlur.uScale = isCompareMode ? 1 : 0.5;
      this.productViews[0].renderTargetTextureBlur.uOffset = isCompareMode ? 0 : 0.25;
      this.productViews[1].renderTargetTextureBlur.uScale = isCompareMode ? 1 : 0.5;
      this.productViews[1].renderTargetTextureBlur.uOffset = isCompareMode ? 0 : 0.25;

      // Horizontal blur
      this.productViews[0].renderTargetTextureBlur._postProcesses[0].direction.x = isCompareMode
        ? this.blurFactor * 4
        : this.blurFactor * 2;
      // Vertical blur
      this.productViews[0].renderTargetTextureBlur._postProcesses[1].direction.y = this.blurFactor;
    },

    addBlur(texture, blurFactorHorizontal, blurFactorVertical) {
      const kernel = 32;
      const blurHorizontal = new BlurPostProcess(
        '',
        new Vector2(blurFactorHorizontal, 0),
        kernel,
        1,
        undefined,
        undefined,
        this.engine
      );
      const blurVertical = new BlurPostProcess(
        '',
        new Vector2(0, blurFactorVertical),
        kernel,
        1,
        undefined,
        undefined,
        this.engine
      );
      texture.addPostProcess(blurHorizontal);
      texture.addPostProcess(blurVertical);

      texture.ignoreCameraViewport = true;
    },

    resize() {
      const size = computeSize();

      // renderer.setPixelRatio(window.devicePixelRatio);
      this.engine.setSize(size.width, size.height);
    },

    onMouseDown() {
      if (this.mouseDownTimer) {
        clearTimeout(this.mouseDownTimer);
        this.mouseDownTimer = null;
      }
      this.isMouseDown = true;
    },

    onMouseUp() {
      this.mouseDownTimer = setTimeout(() => {
        this.isMouseDown = false;
      }, 500);
    },

    computeFilename(filename) {
      if (!/^http[s]?:/.test(filename)) {
        filename = `/demo/360/${filename}`;
      }
      return filename;
    },

    updateProductTextures() {
      const productList = this.$store.getters.getComparisonProducts(this.$route.params.id);
      if (
        this.$store.getters.comparisonProductLeft &&
        productList.find(product => product.id === this.$store.getters.comparisonProductLeft.id)
      ) {
        this.setProductLeft(this.$store.getters.comparisonProductLeft);
      } else {
        this.setProductLeft(productList[0]);
      }

      if (
        this.$store.getters.comparisonProductRight &&
        productList.find(product => product.id === this.$store.getters.comparisonProductRight.id)
      ) {
        this.setProductRight(this.$store.getters.comparisonProductRight);
      } else {
        this.setProductRight(productList[productList.length - 1]);
      }
    },

    setProductLeft(product) {
      if (product && this.productViews[0]) {
        this.productViews[0].materialBlur.opacityTexture = new Texture(
          this.getProductBlurPath(product, this.isCompareMode),
          this.scene
        );
        this.checkTextureLoading(this.productViews[0].materialBlur.opacityTexture);

        this.productViews[0].dashMaterial.opacityTexture = new Texture(
          this.getProductDashPath(product, this.isCompareMode),
          this.scene
        );
        this.checkTextureLoading(this.productViews[0].dashMaterial.opacityTexture);

        this.setContrast(0, product.contrast);

        this.setSharpness(0, product.sharpness);
      }
      this.productViews[0].dashPlane.setEnabled(this.$store.getters.showDashes);
    },

    setProductRight(product) {
      if (product && this.productViews[1]) {
        this.productViews[1].materialBlur.opacityTexture = new Texture(
          this.getProductBlurPath(product, this.isCompareMode),
          this.scene
        );
        this.checkTextureLoading(this.productViews[1].materialBlur.opacityTexture);

        this.productViews[1].dashMaterial.opacityTexture = new Texture(
          this.getProductDashPath(product, this.isCompareMode),
          this.scene
        );
        this.checkTextureLoading(this.productViews[1].dashMaterial.opacityTexture);

        this.setContrast(1, product.contrast);

        this.setSharpness(1, product.sharpness);
      }
      this.productViews[1].dashPlane.setEnabled(this.$store.getters.showDashes && this.$store.getters.isCompareMode);
    },
    setContrast(productIndex, contrast) {
      if (contrast) {
        let imageProcessingConfiguration = this.productViews[productIndex].viewport.material
          .imageProcessingConfiguration;
        // if (!imageProcessingConfiguration) {
        imageProcessingConfiguration = new ImageProcessingConfiguration();

        this.productViews[productIndex].viewport.material.imageProcessingConfiguration = imageProcessingConfiguration;
        this.productViews[
          productIndex
        ].viewportBlur.material.imageProcessingConfiguration = imageProcessingConfiguration;
        // }
        imageProcessingConfiguration.contrast = this.computeProcessingContrast(contrast);
      }
    },
    computeProcessingContrast(contrast) {
      const result = 1 + (1 - contrast) / 15;

      return result;
    },
    setSharpness(productIndex, sharpness) {
      let sharpenPostProcess = this.productViews[productIndex].sharpenPostProcess;
      let texture = this.productViews[productIndex].viewport.material.emissiveTexture;
      if (!sharpenPostProcess) {
        sharpenPostProcess = new SharpenPostProcess(
          'SharpenPostProcess' + productIndex,
          1,
          this['camera' + (productIndex + 1)],
          0,
          this.engine,
          false
        );
        this.productViews[productIndex].sharpenPostProcess = sharpenPostProcess;
        texture.addPostProcess(sharpenPostProcess);
        texture.ignoreCameraViewport = true;
      }
      sharpenPostProcess.edgeAmount = ((3 - sharpness) / 2) * (productIndex === 0 ? 1 : 1 / 3);
      sharpenPostProcess.autoClear = true;

      // texture = this.productViews[productIndex].materialViewportFull.emissiveTexture;
      // texture.addPostProcess(sharpenPostProcess);
      // texture.ignoreCameraViewport = true;
    },
    getProductBlurPath(product, returnFullImagePath) {
      return `/demo/glass/blurmap-${product.id}${returnFullImagePath ? '_full' : ''}.png`;
    },
    getProductDashPath(product, returnFullImagePath) {
      return `/demo/glass/dash-${product.id}${returnFullImagePath ? '_full' : ''}.png`;
    },
    showProductRight(isCompareMode) {
      if (!this.productViews[1]) {
        return;
      }

      this.productViews[1].parentGroup.setEnabled(isCompareMode);
      this.productViews[1].dashPlane.setEnabled(this.$store.getters.showDashes);
    },
    checkTextureLoading(texture) {
      if (texture) {
        texture.onLoadObservable.addOnce(() => {
          this.forceRender();
        });
      }
    },
    forceRender(timeout = 1000) {
      this.nbTexturesLoading++;
      setTimeout(() => {
        this.nbTexturesLoading--;
      }, timeout);
    },
  },
  created() {},
  mounted: function() {
    this.unwatchers.push(
      this.$store.watch(
        (state, getters) => getters.comparisonProductLeft,
        newValue => {
          this.setProductLeft(newValue);
          // Update values according to the compare mode
          this.setCompareMode(this.$store.getters.isCompareMode);
        }
      ),
      this.$store.watch(
        (state, getters) => getters.comparisonProductRight,
        newValue => {
          this.setProductRight(newValue);
          // Update values according to the compare mode
          this.setCompareMode(this.$store.getters.isCompareMode);
        }
      ),
      this.$store.watch(
        (state, getters) => getters.showDashes,
        newValue => {
          if (this.productViews[0] && this.productViews[0].dashPlane) {
            this.productViews[0].dashPlane.setEnabled(newValue);
            this.forceRender();
          }
          if (this.productViews[1] && this.productViews[1].dashPlane) {
            this.productViews[1].dashPlane.setEnabled(newValue);
            this.forceRender();
          }
        }
      ),
      this.$store.watch(
        (state, getters) => getters.isCompareMode,
        newValue => {
          this.setCompareMode(newValue);
        }
      )
    );
    const canvas = this.$refs['canvas360'];

    this.engine = this.initEngine(canvas);

    this.initScene(canvas);

    this.setCompareMode(this.$store.getters.isCompareMode);

    // this.scene.debugLayer.show();

    this.resize();

    this.nbTexturesLoading++;
    this.scene.executeWhenReady(() => {
      setTimeout(() => {
        this.nbTexturesLoading--;
      }, 1000);
    });

    this.engine.runRenderLoop(() => {
      if (this.isMouseDown || this.nbTexturesLoading > 0) {
        this.scene.render();
        // this.$log.debug(this.nbTexturesLoading, this.engine.getFps().toFixed(0) + ' FPS');
      }
      // this.$store.commit("setFps", this.engine.getFps().toFixed(0));
    });

    // Resize
    window.addEventListener('resize', this.resize);
    this.$refs['canvas360'].addEventListener('pointerdown', this.onMouseDown);
    window.addEventListener('pointerup', this.onMouseUp);
  },
  destroyed() {
    removeEventListeners();
    window.removeEventListener('resize', this.resize);
    // this.$refs['canvas360'].removeEventListener('pointerdown', this.onMouseDown);
    window.removeEventListener('pointerup', this.onMouseUp);

    // Remove all watchers
    let unwatchMethod;
    while (this.unwatchers.length > 0) {
      // Get the "unwatch" methods...
      unwatchMethod = this.unwatchers.pop();
      // ... and call it!
      unwatchMethod();
    }
    this.scene.dispose();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  width: 100%;
  min-width: 100%;
}

.photo-compare-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.container {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.demo360 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: stretch;
}

#canvas360 {
  cursor: url('../../../assets/ic-grab.svg'), pointer;
  touch-action: none;
}

.limit {
  z-index: 1999999;
  width: 1px;
  height: 100%;
  border-right: 1px solid white;
  position: absolute;
  left: 50%;
  top: 0;
}
</style>
<!--
<style>
#scene-explorer-host,
#inspector-host {
  position: absolute !important;
}
</style>
-->
